module.exports = __webpack_public_path__ + "img/yorkie-et-compagnons.19f230b4.jpg";